import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import ChartTable from './ChartTable';

const schema: JSONSchema7 = {
    title: 'Chart Table',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        dataKey: {
            type: 'string',
            title: 'Data Key',
            default: '',
        },
        headerRow: {
            type: 'string',
            title: 'Table Header Row',
            default: '',
            description: 'Enter comma seperated values',
        },
        colors: {
            type: 'string',
            title: 'Add swatch colors',
            default: '',
            description: 'Enter JSON array',
        },
        columns: {
            type: 'array',
            title: 'Add Table columns',
            items: {
                type: 'object',
                properties: {
                    label: { type: 'string', description: 'Column header text' },
                    value: { type: 'string', description: 'Coulmn data key' },
                    isIncludeColor: { type: 'boolean', description: 'Include color' },
                },
            },
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        dependencies: {
            ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['dataKey', 'headerRow', 'colors', 'columns'],
        Accessibility: ['disableTabStaticData'],
    },
];

const ChartTableWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: ChartTable,
    id: 'ChartTable',
    group: 'table',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ChartTableWidget;
